"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_2 = require("react");
var Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete"));
var TextField_1 = __importDefault(require("../TextField/TextField"));
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("..");
var util_localization_1 = __importStar(require("@sport-thieme/util-localization"));
util_localization_1.default.addTranslations('de', { 'No options': 'Keine Optionen' });
exports.default = react_2.forwardRef(function Autocomplete(props, ref) {
    var label = props.label, renderInput = props.renderInput, getOptionLabel = props.getOptionLabel, _a = props.defaultTextFieldProps, defaultTextFieldProps = _a === void 0 ? { variant: 'outlined', hiddenLabel: Boolean(label) === false } : _a, renderTags = props.renderTags, placeholder = props.placeholder, _b = props.loadingText, loadingText = _b === void 0 ? util_localization_1.localize(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Loading\u2026"], ["Loading\u2026"]))) : _b, _c = props.noOptionsText, noOptionsText = _c === void 0 ? util_localization_1.localize(templateObject_2 || (templateObject_2 = __makeTemplateObject(["No options"], ["No options"]))) : _c, chipProps = props.chipProps, autoCompleteProps = __rest(props, ["label", "renderInput", "getOptionLabel", "defaultTextFieldProps", "renderTags", "placeholder", "loadingText", "noOptionsText", "chipProps"]);
    var defaultGetOptionLabel = function (option) { return findOption(option); };
    var multiple = props.multiple;
    var classes = useStyles({ multiple: multiple, defaultTextFieldProps: defaultTextFieldProps, label: label });
    var getTheOptionLabel = getOptionLabel !== null && getOptionLabel !== void 0 ? getOptionLabel : defaultGetOptionLabel;
    return (jsx_runtime_1.jsx(Autocomplete_1.default, __assign({}, autoCompleteProps, { getOptionLabel: getTheOptionLabel, loadingText: loadingText, noOptionsText: noOptionsText, renderTags: renderTags !== null && renderTags !== void 0 ? renderTags : (function (tagValue, getTagProps) {
            return tagValue.map(function (option, index) { return (react_1.createElement(__1.Chip, __assign({ size: defaultTextFieldProps.margin === 'dense' ? 'small' : 'medium', color: autoCompleteProps.variant === 'filled' ? 'primary' : 'default' }, chipProps, { label: getTheOptionLabel(option), key: index }, getTagProps({ index: index })))); });
        }), placeholder: placeholder, renderInput: renderInput !== null && renderInput !== void 0 ? renderInput : (function (params) {
            var _a;
            return (jsx_runtime_1.jsx(TextField_1.default, __assign({}, params, (defaultTextFieldProps || {}), { classes: __assign({ root: classnames_1.default((_a = defaultTextFieldProps.classes) === null || _a === void 0 ? void 0 : _a.root, classes.root) }, classes), label: label, placeholder: placeholder, variant: autoCompleteProps.variant }), void 0));
        }), ref: ref }), void 0));
});
var useStyles = core_1.makeStyles(function (theme) {
    return {
        root: {
            '& .MuiFilledInput-root': {
                paddingTop: function (_a) {
                    var _b = _a.defaultTextFieldProps, _c = _b === void 0 ? {} : _b, hiddenLabel = _c.hiddenLabel;
                    return (hiddenLabel ? 9 : 16) + "px";
                },
                paddingBottom: function (_a) {
                    var _b = _a.defaultTextFieldProps, _c = _b === void 0 ? {} : _b, hiddenLabel = _c.hiddenLabel;
                    return (hiddenLabel ? 9 : 3) + "px";
                },
                borderRadius: function (props) { var _a; return ((_a = props.defaultTextFieldProps) === null || _a === void 0 ? void 0 : _a.square) ? 0 : theme.shape.borderRadius; },
                '&.MuiFilledInput-marginDense': {
                    paddingTop: function (_a) {
                        var _b = _a.defaultTextFieldProps, _c = _b === void 0 ? {} : _b, hiddenLabel = _c.hiddenLabel;
                        return (hiddenLabel ? 10 : 16) + "px";
                    },
                    paddingBottom: function (_a) {
                        var _b = _a.defaultTextFieldProps, _c = _b === void 0 ? {} : _b, hiddenLabel = _c.hiddenLabel;
                        return (hiddenLabel ? 10 : 4) + "px";
                    },
                },
            },
            '& .MuiInputLabel-filled': {
                transform: function (_a) {
                    var multiple = _a.multiple, _b = _a.defaultTextFieldProps, _c = _b === void 0 ? {} : _b, margin = _c.margin;
                    return multiple ? "translate(12px, " + (margin === 'dense' ? '15' : '20') + "px) scale(1)" : undefined;
                },
                '&.MuiInputLabel-shrink': {
                    transform: function (_a) {
                        var multiple = _a.multiple;
                        return (multiple ? 'translate(12px, 5px) scale(0.75)' : undefined);
                    },
                },
            },
            '& .MuiInputLabel-outlined.MuiInputLabel-marginDense': {
                transform: 'translate(14px, 9px) scale(1);',
            },
            '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
                transform: 'translate(14px, -6px) scale(0.75)',
            },
        },
    };
});
function hasOwnProperty(obj, prop) {
    return obj.hasOwnProperty(prop);
}
var findOption = function (option) {
    if (typeof option === 'string')
        return option;
    else if (typeof option === 'object' &&
        option !== null &&
        hasOwnProperty(option, 'title') &&
        typeof option.title === 'string') {
        return option.title;
    }
    else if (typeof option === 'object' &&
        option !== null &&
        hasOwnProperty(option, 'label') &&
        typeof option.label === 'string') {
        return option.label;
    }
    else if (typeof option === 'object' &&
        option !== null &&
        hasOwnProperty(option, 'name') &&
        typeof option.name === 'string') {
        return option.name;
    }
    return '';
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=Autocomplete.js.map